import React from 'react';
import { Check } from 'lucide-react';
import { usePopup } from '../context/PopupContext';

const CompanyFormationPricing = () => {
  const { openPopup } = usePopup();

  const packages = [
    {
      name: 'Basic',
      price: '$299',
      popular: false,
      features: [
        'Business Name Search',
        'Preparation of Articles of Organization/Incorporation',
        'Filing with Secretary of State',
        'Unlimited Phone & Email Support',
        'Next Business Day Processing'
      ]
    },
    {
      name: 'Standard',
      price: '$449',
      popular: true,
      features: [
        'Everything in Basic',
        'Federal Tax ID (EIN)',
        'Operating Agreement / Corporate Bylaws',
        'Banking Resolution',
        'Membership Certificates / Stock Certificates',
        'Company Seal'
      ]
    },
    {
      name: 'Premium',
      price: '$599',
      popular: false,
      features: [
        'Everything in Standard',
        'Registered Agent Service (1 Year)',
        'Business Website Domain',
        'Business Email Address',
        'Express Processing',
        'Compliance Calendar'
      ]
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-[#C0392B] via-[#A93226] to-[#8B2E1F] relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-white/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/5 rounded-full blur-3xl" />
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)', backgroundSize: '40px 40px'}} />
      </div>
      
      <div className="container mx-auto px-4 max-w-[1320px] relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {packages.map((pkg, index) => (
            <div
              key={index}
              className={`bg-white rounded-2xl overflow-hidden flex flex-col ${
                pkg.popular ? 'ring-4 ring-white shadow-2xl transform scale-105' : 'shadow-xl'
              }`}
            >
              {/* Header with package name */}
              <div className="bg-[#2C3E50] text-white py-6 px-6 text-center relative">
                {pkg.popular && (
                  <div className="absolute top-0 right-0 bg-[#C0392B] text-white px-4 py-1 text-xs font-bold">
                    Most Popular
                  </div>
                )}
                <h3 className="text-2xl font-bold uppercase tracking-wide">{pkg.name}</h3>
              </div>

              {/* Price section */}
              <div className="bg-white py-8 px-6 text-center border-b border-gray-200">
                <div className="mb-2">
                  <span className="text-gray-500 text-sm">+ State Filing Fee</span>
                </div>
                <div className="mb-4">
                  <span className="text-6xl font-bold text-[#C0392B]">{pkg.price}</span>
                </div>
                <div className="mb-2">
                  <span className="text-gray-500 text-sm">+ State Filing Fee</span>
                </div>
                <button
                  onClick={openPopup}
                  className={`w-full mt-4 py-3 px-6 rounded-lg font-bold text-lg transition-all duration-300 ${
                    pkg.popular
                      ? 'bg-[#C0392B] text-white hover:bg-[#A93226] shadow-lg'
                      : 'bg-white text-[#C0392B] border-2 border-[#C0392B] hover:bg-[#C0392B] hover:text-white'
                  }`}
                >
                  Get a Trademark
                </button>
              </div>

              {/* Features list */}
              <div className="p-6 flex-1">
                <ul className="space-y-3">
                  {pkg.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start text-sm">
                      <Check className="w-5 h-5 text-[#C0392B] flex-shrink-0 mr-3 mt-0.5" />
                      <span className="text-[#2C3E50]">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CompanyFormationPricing;
